import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ProjectContext = createContext();

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};

export const ProjectProvider = ({ children }) => {
  const [selectedProject, setSelectedProject] = useState(() => {
    // Initialize from localStorage
    try {
      const saved = localStorage.getItem('selectedProject');
      return saved ? JSON.parse(saved) : { id: '', name: '' };
    } catch (error) {
      console.error('Error reading selectedProject from localStorage:', error);
      return { id: '', name: '' };
    }
  });

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Persist selected project to localStorage
  useEffect(() => {
    try {
      localStorage.setItem('selectedProject', JSON.stringify(selectedProject));
    } catch (error) {
      console.error('Error saving selectedProject to localStorage:', error);
    }
  }, [selectedProject]);

  const selectProject = useCallback((projectId, projectName) => {
    setSelectedProject({
      id: projectId,
      name: projectName
    });
  }, []);

  const clearProject = useCallback(() => {
    setSelectedProject({ id: '', name: '' });
  }, []);

  const updateProjects = useCallback((projectsList) => {
    setProjects(projectsList);
  }, []);

  const value = {
    selectedProject,
    selectProject,
    clearProject,
    projects,
    updateProjects,
    loading,
    setLoading,
    error,
    setError
  };

  return (
    <ProjectContext.Provider value={value}>
      {children}
    </ProjectContext.Provider>
  );
};

export default ProjectContext;
